import React from 'react'
import PropTypes from 'prop-types'
import { Box, Label, Input, Tooltip, FormField } from 'pcln-design-system'
import { Warning as WarningIcon, Calendar as CalendarIcon } from 'pcln-icons'

const DateField = React.forwardRef(
  (
    {
      name,
      label,
      placeholder,
      value,
      error,
      isMobile,
      errorZIndex,
      hideTooltip = false,
      ...props
    },
    ref
  ) => {
    const dateFieldDesktopStyle = value
      ? { height: '56px', paddingTop: '18px', paddingBottom: '10px' }
      : { height: '56px' }

    const dateFieldMobileStyle = value
      ? { height: '46px', paddingTop: '20px', paddingBottom: '8px' }
      : { height: '46px' }

    const showError = !hideTooltip && error !== ''

    return (
      <Box>
        <FormField>
          <Label autoHide htmlFor={name} width="auto">
            {label}
          </Label>
          <CalendarIcon color="primary" />
          <Input
            data-datepicker
            {...props}
            color={error ? 'error' : ''}
            id={name}
            name={name}
            placeholder={placeholder || label}
            value={value}
            autoComplete="off"
            readOnly
            style={isMobile ? dateFieldMobileStyle : dateFieldDesktopStyle}
            ref={ref}
          />
          {showError && <WarningIcon color="error" size={20} />}
        </FormField>
        {showError && (
          <Tooltip bottom right color="error" zIndex={errorZIndex}>
            {error}
          </Tooltip>
        )}
      </Box>
    )
  }
)

DateField.defaultProps = {
  isMobile: false,
  hideTooltip: false,
  errorZIndex: 1,
  error: '',
  label: '',
  placeholder: ''
}

DateField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  error: PropTypes.string,
  errorZIndex: PropTypes.number,
  hideTooltip: PropTypes.bool
}

export default DateField
